import { Component, EventEmitter, Input, Output } from '@angular/core';
import { firstValueFrom, map, shareReplay, tap } from 'rxjs';
import { Course, CourseChat, User } from 'src/index';
import { AuthenticationService, ChatService, CoursesService } from 'src/index/services.index';

@Component({
  selector: 'meta-chat-toggler',
  templateUrl: './chat-toggler.component.html',
  styleUrls: ['./chat-toggler.component.scss']
})
export class ChatTogglerComponent {
  @Input() isGlobal: boolean = true;
  @Input() set course(c: Course | undefined) {
    if (c) {
      this.joinCourseRoom(c.uuid);
    }
  };
  @Input() set courseId(cId: string | undefined) {
    if (cId) {
      this.joinCourseRoom(cId);
    }
  };

  private _coursesIds: string[] | undefined;
  @Input() set coursesIds(cIds: string[] | undefined) {
    if (cIds && Array.isArray(cIds) && cIds.length > 0) {
      this._coursesIds = cIds;
      this.joinCoursesRooms(cIds);
    }
  };
  get coursesIds() { return this._coursesIds; }

  @Output() clicked = new EventEmitter();

  constructor(
    public chatService: ChatService,
    private authService: AuthenticationService<User>,
    private coursesService: CoursesService,
  ) {
    firstValueFrom(this.coursesService.getStudyPathCourses().pipe(
      map(courses => courses.map(course => ({ course } as CourseChat))),
      tap(courses => courses.unshift({
        course: {
          uuid: 'notifications',
          title: 'Notifiche',
          image: '',
          duration: '',
          description: '',
        }
      })),
      map(courses => courses.map(course => course.course.uuid)),
      shareReplay(1),
    )).then(coursesIds => this.coursesIds = coursesIds);
  }

  toggleChat() {
    const roomId = this.course ? this.course.uuid : (this.courseId || this.coursesIds?.[0]) ?? undefined;
    if (!this.isGlobal) {
      if (roomId) {
        this.chatService.$notifications().set(roomId, 0);
      }
      this.clicked.emit();
    } else {
      this.chatService.toggleChat$.emit();
    }
  }

  joinCourseRoom(courseId: string) {
    firstValueFrom(this.authService.currentUser$)
      .then(currentUser => {
        if (courseId && currentUser) {
          this.chatService.joinRooms(currentUser, [ courseId ]);
        }
      });
  }

  joinCoursesRooms(coursesIds: string[]) {
    firstValueFrom(this.authService.currentUser$)
      .then(currentUser => {
        if (Array.isArray(coursesIds) && coursesIds.length > 0 && currentUser) {
          this.chatService.joinRooms(currentUser, coursesIds);
        }
      });
  }
}
